var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 466,
    height: 457,
    viewBox: "0 0 466 457",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M312.041 181.545L184.498 178.433L118.533 287.068L180.119 398.8L307.646 401.902L373.612 293.267L312.041 181.545Z",
    fill: "#ACA4E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M339.085 115.954L225.029 138.889L172.13 242L220.241 347.626L333.033 376.282L425.691 306.378L428.386 190.52L339.085 115.954Z",
    fill: "#776BCE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M187.131 39.0828L82.2011 51.4845L26.756 140.949L62.5507 240.088L162.556 274.296L251.574 217.812L262.506 113.129L187.131 39.0828Z",
    fill: "#776BCE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg32);
export default __webpack_public_path__ + "static/media/32.e17dbd9a7d7f5578694f7403ab7fbd06.svg";
export { ForwardRef as ReactComponent };